import styled from 'styled-components';
import { spacingMixin } from '@zillow/constellation';

var Picture = /*#__PURE__*/styled.picture.withConfig({
  componentId: "sc-1mn78nr-0"
})(["display:block;", ""], spacingMixin);
Picture.propTypes = {};
Picture.defaultProps = {};
/** @component */
var Picture$1 = Picture;

export { Picture$1 as default };
